import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './used-machines/HeroSection';
import { IntroSection } from './used-machines/IntroSection';
import { CategorySidebar } from './used-machines/CategorySidebar';
import { InventoryListingSection } from './used-machines/InventoryListingSection';
import { UsedMachinePopup } from './used-machines/UsedMachinePopup';
export function UsedMachinesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-4105">
      <SeoBar data-id="element-4106" />
      <Header data-id="element-4107" />
      <main className="flex-grow" data-id="element-4108">
        <div className="w-full bg-gray-50 pb-20 min-h-screen" data-id="element-4109">
          <HeroSection data-id="element-4110" />
          <IntroSection data-id="element-4111" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-4112">
            <div className="flex flex-col lg:flex-row gap-8" data-id="element-4113">
              <CategorySidebar data-id="element-4114" />
              <InventoryListingSection data-id="element-4115" />
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-4116" />
      <UsedMachinePopup data-id="element-4117" />
    </div>;
}